import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterProjectByName'
})
export class FilterProjectByNamePipe implements PipeTransform {

  transform(hours: any[], searchTerm: string): any[] {
    if (!hours || !searchTerm) {
      return hours;  
    }
    return hours.filter(hour => 
      hour.project && hour.project.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }
}
